module.exports = __webpack_public_path__ + "static/media/icons_ticket.5a46b4b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons_ticket.svg
// module id = 101
// module chunks = 0